module.exports = __webpack_public_path__ + "static/media/pl.8a28634b.svg";